module.exports = __webpack_public_path__ + "img/chris-rename.48b90cfa.svg";